/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {startPasskeyVerification} from '../api'

export const useMutationStartPasskeyVerification = createReactQueryMutationHook('startPasskeyVerification', startPasskeyVerification)
